/* eslint-disable max-len */
import { DBConfig } from 'ngx-indexed-db';
import { AccountType } from 'src/app/components/shared/models/interface/accountType.enum';
import { ApiPaymentMovementType } from 'src/app/components/shared/models/interface/apiPaymentMovementType.enum';

export const countries = {
  countries: [
    {
      id: 1,
      name: 'Colombia',
      geoName: 'CO',
      ico: 'assets/layout/images/flags/cop.ico.png',
      languageKey: 'es',
      maxDeclaredValue: 2000000,
      timeZone: 'America/Bogota',
      currency: 'COP',
      chargeCreditCardAmount: 300,
      center: { lat: 4.570868, lng: -74.297333 },
      removeDecimal: true,
      indicative: '57',
    },
    {
      id: 3,
      name: 'Mexico',
      geoName: 'MX',
      ico: 'assets/layout/images/flags/mx.ico.png',
      languageKey: 'es-mx',
      maxDeclaredValue: 11363,
      timeZone: 'America/Mexico_City',
      currency: 'MXN',
      chargeCreditCardAmount: 1.5,
      center: { lat: 20.4654637, lng: -103.7340596 },
      holdZeroDecimal: true,
      indicative: '52',
    },
  ],
};

export const clientAnalitic = [{ id: '35715' }, { id: '21374' }, { id: '31742' }];

export const sharedConstants = {
  featureFlagEnable: 'ON',
  filterForPermission: {
    filterName: 'rolebyuser',
    filterValue: '2',
  },
  enableAllPermissions: false,
  disableAllLogs: false,
  statusToFilterCity: '3',
  hideUnauthorizedButton: ['usuarios'],
  mapOptions: {
    gestureHandling: 'greedy',
    styles: null,
    mapTypeControl: false,
    streetViewControl: false,
    zoomControl: true,
    fullscreenControl: false,
    zoom: 11,
    width: '100%',
    height: '100%',
    center: { lat: 4.6404148, lng: -74.1586533 },
  },
  orderRateData: {
    question: 7,
    device: 4,
    version: null,
  },
  isCancelDescription: ['4', '8'],
  orderOs: 'Plataforma 1.0',
  cryptoKey: '`";ñmuñ;"`',
};

export const ui = {
  toastData: {
    life: 10000,
    position: 'top-right',
  },
};

export const ModalState = {
  CLOSE: false,
  OPEN: true,
};

export const freshChat = {
  token: '42738f47-9f03-4e6d-b4ea-c071c0846475',
  host: 'https://wchat.freshchat.com',
  siteId: 'Plataforma MU',
  locale: 'es',
  tags: ['clientes-plataforma'],
  config: { headerProperty: { backgroundColor: '#654EA3' } },
};

export const kushki = {
  provide: 'KUSHKI',
  clientapp: 'pu-www',
  source: 'PAGO_INMEDIATO',
  source_recharge: 'RECARGA_PAQUETE',
};

export const accountTypeList = [
  { id: AccountType.ADMIN },
  { id: AccountType.RESOURCE },
  { id: AccountType.B2C, icon: AccountType.B2C },
  { id: AccountType.COMPANY, icon: AccountType.COMPANY },
  { id: AccountType.DIRECT_RESOURCE },
];

export const muAddressData = {
  addressDelay: 1500,
  addressCurrentKey: 'mu-current-address',
  favoriteProvider: 'MU',
};

export const muFavoriteAddress = {
  favoriteAddressAlias: 'mu-favorite-address-alias',
  addressCurrentKey: 'mu-favorite-address-current',
};

export const muOldPlatformWeb = {
  oldUserPlatform: 'mu-old-user-platform-web',
};

export const muPublicAccess = [
  {
    address: '/co/ext/cotizar-servicio',
  },
  {
    address: '/mx/ext/cotizar-servicio',
  },
  {
    address: '/co/ext/mercancia',
  },
  {
    address: '/mx/ext/mercancia',
  },
  {
    address: '/express/pago',
  },
];
export const paymentsMovementsConstants = {
  freeRechargeMovementList: [
    ApiPaymentMovementType.BANK_TRANSFER,
    ApiPaymentMovementType.CREDIT_CARD,
    ApiPaymentMovementType.PSE,
  ],
  specificRechargeMovementList: [
    ApiPaymentMovementType.MOVEMENT_TYPE_1,
    ApiPaymentMovementType.MOVEMENT_TYPE_2,
    ApiPaymentMovementType.MOVEMENT_TYPE_3,
    ApiPaymentMovementType.MOVEMENT_TYPE_4,
    ApiPaymentMovementType.MOVEMENT_TYPE_5,
    ApiPaymentMovementType.MOVEMENT_TYPE_6,
    ApiPaymentMovementType.MOVEMENT_TYPE_7,
    ApiPaymentMovementType.MOVEMENT_TYPE_8,
    ApiPaymentMovementType.MOVEMENT_TYPE_9,
    ApiPaymentMovementType.MOVEMENT_TYPE_10,
    ApiPaymentMovementType.MOVEMENT_TYPE_11,
    ApiPaymentMovementType.MOVEMENT_TYPE_12,
    ApiPaymentMovementType.MOVEMENT_TYPE_13,
    ApiPaymentMovementType.MOVEMENT_TYPE_14,
    ApiPaymentMovementType.MOVEMENT_TYPE_15,
    ApiPaymentMovementType.MOVEMENT_TYPE_16,
    ApiPaymentMovementType.MOVEMENT_TYPE_17,
    ApiPaymentMovementType.MOVEMENT_TYPE_18,
    ApiPaymentMovementType.MOVEMENT_TYPE_19,
    ApiPaymentMovementType.MOVEMENT_TYPE_20,
    ApiPaymentMovementType.MOVEMENT_TYPE_21,
    ApiPaymentMovementType.MOVEMENT_TYPE_22,
    ApiPaymentMovementType.MOVEMENT_TYPE_23,
    ApiPaymentMovementType.MOVEMENT_TYPE_26,
    ApiPaymentMovementType.MOVEMENT_TYPE_27,
    ApiPaymentMovementType.MOVEMENT_TYPE_28,
    ApiPaymentMovementType.MOVEMENT_TYPE_36,
    ApiPaymentMovementType.MOVEMENT_TYPE_37,
    ApiPaymentMovementType.MOVEMENT_TYPE_38,
    ApiPaymentMovementType.MOVEMENT_TYPE_39,
    ApiPaymentMovementType.MOVEMENT_TYPE_40,
    ApiPaymentMovementType.MOVEMENT_TYPE_41,
    ApiPaymentMovementType.MOVEMENT_TYPE_42,
    ApiPaymentMovementType.MOVEMENT_TYPE_43,
    ApiPaymentMovementType.MOVEMENT_TYPE_44,
    ApiPaymentMovementType.MOVEMENT_TYPE_45,
    ApiPaymentMovementType.MOVEMENT_TYPE_47,
    ApiPaymentMovementType.MOVEMENT_TYPE_48,
    ApiPaymentMovementType.MOVEMENT_TYPE_49,
    ApiPaymentMovementType.MOVEMENT_TYPE_50,
    ApiPaymentMovementType.MOVEMENT_TYPE_51,
    ApiPaymentMovementType.MOVEMENT_TYPE_52,
    ApiPaymentMovementType.MOVEMENT_TYPE_53,
    ApiPaymentMovementType.MOVEMENT_TYPE_54,
    ApiPaymentMovementType.MOVEMENT_TYPE_55,
    ApiPaymentMovementType.MOVEMENT_TYPE_56,
    ApiPaymentMovementType.MOVEMENT_TYPE_57,
    ApiPaymentMovementType.MOVEMENT_TYPE_58,
    ApiPaymentMovementType.MOVEMENT_TYPE_59,
    ApiPaymentMovementType.MOVEMENT_TYPE_60,
    ApiPaymentMovementType.MOVEMENT_TYPE_61,
    ApiPaymentMovementType.MOVEMENT_TYPE_62,
  ],
};

export const paymentRegisterCodeErrorPlatfom = [513, 523, 529, 530, 555];
export const paymentRegisterCodeErrorCard = [503, 504, 541, 543, 551, 553, 563, 565];
export const paymentRegisterCodeErrorTransaction = [
  501, 505, 512, 515, 526, 557, 558, 559, 561, 562, 591, 596,
];
export const paymentRegisterCodeErrorNewCard = [514, 518, 519, 520, 521, 522, 524, 552, 579, 582];

export const staticMapGoogle = {
  key: 'AIzaSyA1S9eSm5c4qjofX4GYLogDNNkKX05pCb0',
};

export const indexDbConfig: DBConfig = {
  name: 'mu',
  version: 2,
  objectStoresMeta: [
    {
      store: 'points_store',
      storeConfig: { keyPath: 'pointId', autoIncrement: false }, // Cambiado a pointId
      storeSchema: [
        { name: 'pointId', keypath: 'pointId', options: { unique: true } },
        { name: 'data', keypath: 'data', options: { unique: false } },
      ],
    },
  ],
};
